/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FcbFormateurPrestationsContratGridDtoPaginatedResults,
  FilterCriteriaInfo,
  FormateurPrestationContratSearch,
  SelectItem,
} from '../models/index';
import {
    FcbFormateurPrestationsContratGridDtoPaginatedResultsFromJSON,
    FcbFormateurPrestationsContratGridDtoPaginatedResultsToJSON,
    FilterCriteriaInfoFromJSON,
    FilterCriteriaInfoToJSON,
    FormateurPrestationContratSearchFromJSON,
    FormateurPrestationContratSearchToJSON,
    SelectItemFromJSON,
    SelectItemToJSON,
} from '../models/index';

export interface FormateurPrestationsContratBaseSearchRequest {
    FormateurPrestationContratSearch?: FormateurPrestationContratSearch;
}

export interface FormateurPrestationsContratGetSearchCriteriasRequest {
    includeListsValues?: boolean;
}

export interface FormateurPrestationsContratGetSelectItemsRequest {
    searchField: string;
}

/**
 * 
 */
export class FormateurPrestationsContratApi extends runtime.BaseAPI {

    /**
     */
    async formateurPrestationsContratBaseSearchRaw(requestParameters: FormateurPrestationsContratBaseSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FcbFormateurPrestationsContratGridDtoPaginatedResults>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/FormateurPrestationsContrat/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FormateurPrestationContratSearchToJSON(requestParameters.FormateurPrestationContratSearch),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FcbFormateurPrestationsContratGridDtoPaginatedResultsFromJSON(jsonValue));
    }

    /**
     */
    async formateurPrestationsContratBaseSearch(requestParameters: FormateurPrestationsContratBaseSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FcbFormateurPrestationsContratGridDtoPaginatedResults> {
        const response = await this.formateurPrestationsContratBaseSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async formateurPrestationsContratGetSearchCriteriasRaw(requestParameters: FormateurPrestationsContratGetSearchCriteriasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FilterCriteriaInfo>>> {
        const queryParameters: any = {};

        if (requestParameters.includeListsValues !== undefined) {
            queryParameters['includeListsValues'] = requestParameters.includeListsValues;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/FormateurPrestationsContrat/criterias`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilterCriteriaInfoFromJSON));
    }

    /**
     */
    async formateurPrestationsContratGetSearchCriterias(requestParameters: FormateurPrestationsContratGetSearchCriteriasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilterCriteriaInfo>> {
        const response = await this.formateurPrestationsContratGetSearchCriteriasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async formateurPrestationsContratGetSelectItemsRaw(requestParameters: FormateurPrestationsContratGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SelectItem>>> {
        if (requestParameters.searchField === null || requestParameters.searchField === undefined) {
            throw new runtime.RequiredError('searchField','Required parameter requestParameters.searchField was null or undefined when calling formateurPrestationsContratGetSelectItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/FormateurPrestationsContrat/criteriaList/{searchField}`.replace(`{${"searchField"}}`, encodeURIComponent(String(requestParameters.searchField))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SelectItemFromJSON));
    }

    /**
     */
    async formateurPrestationsContratGetSelectItems(requestParameters: FormateurPrestationsContratGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SelectItem>> {
        const response = await this.formateurPrestationsContratGetSelectItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
